// Versão do app - gerado automaticamente
export const APP_VERSION = '5.37'
export const BUILD_DATE = '11/05/2026, 18:51'
